
  (function () {
    try {
      var roots = document.querySelectorAll('[data-cw-rev]:not([data-cw-rev-ready])');
      Array.prototype.forEach.call(roots, function (root) {
        root.setAttribute('data-cw-rev-ready', '1');
        var track = root.querySelector('[data-cw-rev-track]');
        var nav = root.querySelector('[data-cw-rev-nav]');
        var prev = root.querySelector('[data-cw-rev-prev]');
        var next = root.querySelector('[data-cw-rev-next]');
        if (!track || !nav || !prev || !next) return;
        function step() {
          var card = track.querySelector('.cw-rev__card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          return card ? card.getBoundingClientRect().width + gap : 300;
        }
        function sync() {
          var max = track.scrollWidth - track.clientWidth;
          nav.hidden = max <= 4;
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= max - 4;
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        var scheduled = false;
        track.addEventListener('scroll', function () { if (scheduled) return; scheduled = true; window.requestAnimationFrame(function () { scheduled = false; sync(); }); }, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      });
    } catch (e) {}
  })();

document.querySelectorAll('[data-of-rg]').forEach(root => {
  if (root.dataset.hsReviewsReady) return;
  root.dataset.hsReviewsReady = 'true';
  const cards = Array.from(root.querySelectorAll('.of-rg__card'));
  const topics = Array.from(root.querySelectorAll('[data-of-rg-topic]'));
  const search = root.querySelector('[data-of-rg-search]');
  const load = root.querySelector('[data-of-rg-load]');
  const shown = root.querySelector('[data-of-rg-shown]');
  const empty = root.querySelector('[data-of-rg-empty]');
  const step = Number(root.dataset.ofRgInitial) || 12;
  let topic = 'all', limit = step;
  const fold = value => value.toLocaleLowerCase().trim();
  const searchable = cards.map(card => fold(card.textContent));
  function render() {
    const query = fold(search?.value || '');
    let total = 0, visible = 0;
    cards.forEach((card, index) => {
      const matchesTopic = topic === 'all' || (card.dataset.topics || '').split(/[\s,]+/).includes(topic);
      const matches = matchesTopic && (!query || searchable[index].includes(query));
      if (matches) total++;
      const hidden = !matches || total > limit;
      if (card.hidden !== hidden) card.hidden = hidden;
      if (!card.hidden) visible++;
    });
    topics.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ofRgTopic === topic)));
    if (shown) shown.textContent = `Showing ${visible} of ${total} reviews`;
    if (empty) empty.hidden = total > 0;
    if (load) load.hidden = visible >= total;
  }
  topics.forEach(button => button.addEventListener('click', () => { topic = button.dataset.ofRgTopic; limit = step; render(); }));
  search?.addEventListener('input', () => { limit = step; render(); });
  load?.addEventListener('click', () => { limit += step; render(); });
  root.querySelectorAll('[data-of-rg-clear]').forEach(button => button.addEventListener('click', () => { topic = 'all'; limit = step; if (search) search.value = ''; render(); }));
  render();
});

document.querySelectorAll('[data-cw-vid]').forEach(root => {
  if (root.dataset.hsVideoReady) return;
  root.dataset.hsVideoReady = 'true';
  const track = root.querySelector('[data-cw-vid-track]');
  const items = Array.from(root.querySelectorAll('[data-cw-vid-item]'));
  const previous = root.querySelector('[data-cw-vid-prev]');
  const next = root.querySelector('[data-cw-vid-next]');
  if (!track || !items.length) return;
  const sync = () => {
    const max = track.scrollWidth - track.clientWidth;
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    const nav = root.querySelector('[data-cw-vid-nav]');
    if (nav) nav.hidden = max <= 2;
  };
  const move = direction => track.scrollBy({left:direction * (items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 12)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  previous?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
  let scheduled = false;
  track.addEventListener('scroll', () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; sync(); }); }, {passive:true});
  new ResizeObserver(sync).observe(track);
  const nearScreen = new IntersectionObserver(entries => entries.forEach(entry => {
    const video = entry.target;
    if (entry.isIntersecting) { if (video.preload === 'none') { video.preload = 'metadata'; video.load(); } }
    else if (!video.paused) video.pause();
  }), {rootMargin:'150px'});
  items.forEach(item => {
    const video = item.querySelector('video'), play = item.querySelector('[data-cw-vid-play]');
    if (!video) return;
    nearScreen.observe(video);
    play?.addEventListener('click', () => { video.play().catch(() => { video.controls = true; item.classList.add('is-playing'); }); });
    video.addEventListener('play', () => { items.forEach(other => { if (other !== item) other.querySelector('video')?.pause(); }); item.classList.add('is-playing'); });
    video.addEventListener('pause', () => item.classList.remove('is-playing'));
    video.addEventListener('ended', () => item.classList.remove('is-playing'));
  });
  sync();
});


